import { addAncillaryToOffer, refundAncillaryFromOffer } from "../../../../app/api/getOffers";
import { patchPassenger } from "../../../../app/api/patchPassenger";
import { patchPurchaser } from "../../../../app/api/patchPurchaser";
import { postFulfillment } from "../../../../app/api/postFulfillment";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IPaymentProcessGuestParams } from "../../../../Orchestrator/Types/Interface/ActionParams/BookingDetailActionParams";
import { IAddAncillaryToOfferRequest, IAddonsPassengerLeg, IAlreadyAddonsForPassenger } from "../../../../Orchestrator/Types/Interface/IAddOns";
import {
  IPatchPassengerRequest,
  IPurchaserRequest
} from "../../../../Orchestrator/Types/Interface/IPurchaserRequest";

export class GuestPaymentProcessAction extends BaseAction<string, IPaymentProcessGuestParams> {
  // Coalesce concurrent invocations: a quick double-click on Pay would
  // otherwise re-fire the refund-offers POST against a booking that has
  // already been modified, producing a 400 BOOKING_MODIFICATION_NOT_ALLOWED.
  protected override deduplicate = true;

  override async run(): Promise<string> {
    let returnString: any = "";
    try {
      const { passengers, bookingId, customer, manageAddonsNewConfirmedAddons, manageAddonsRemovedAddons } = this.params!;
      updateRecoilState("paymentSuccessModalAtom", false);
        let confirmAddonsList: IAddonsPassengerLeg[] = manageAddonsNewConfirmedAddons || [] as IAddonsPassengerLeg[]
      let removedAddonsList: IAlreadyAddonsForPassenger[] = manageAddonsRemovedAddons || [] as IAlreadyAddonsForPassenger[]
      const isManageSeating = getRecoilStateValue("isManageSeatingAtom") || false
      const patchAddonsOnConfirm =
        (getRecoilStateValue("patchAddonsOnConfirmAtom") as boolean) ?? true;
      
      // Patch passenger information
      for (const passenger of passengers) {

        const patchRequest: IPatchPassengerRequest = {
          id: passenger.id,
          summary: `${passenger.detail?.firstName || ""} ${passenger.detail?.lastName || ""}`,
          externalRef: passenger.externalRef,
          type: passenger.type,
          detail: {
            preferredLanguage: "en",
            summary: `${passenger.detail.firstName} ${passenger.detail.lastName}`,
            firstName: passenger.detail.firstName,
            lastName: passenger.detail.lastName,
            email: customer.email,
            phoneNumber: customer.phoneNumber,
          },
          // age: age, // We can not patch age, because if prebook call with 16 and on checkout if age is calculating other than 16 then after a sales API get fail
          dateOfBirth: passenger?.dateOfBirth
            ? passenger.dateOfBirth instanceof Date
              ? passenger.dateOfBirth.toISOString()
              : new Date(passenger.dateOfBirth).toISOString()
            : "",
        };
        await patchPassenger(patchRequest, bookingId);
      }

      if (customer) {
        const purchaserRequest: IPurchaserRequest = {
          externalRef: passengers[0]?.externalRef || "",
          detail: {
            summary: "",
            firstName: customer.firstName,
            lastName: customer.lastName,
            email: customer.email,
            phoneNumber: customer.phoneNumber,
          },
        };
        try {
          await patchPurchaser(bookingId, purchaserRequest);
        } catch {
          // Handle error
        }
      }

      /**
       * Removed ancillary(Addons) from the booked offer
       * First prepare all the ancillary(addons) Is's for all trip
       * Second, refund that all the ancillary.
       * Third, patch the offer into booking.
      */
      if (!patchAddonsOnConfirm && removedAddonsList.length > 0) {
        const allAncillaryFulfillmentIds = removedAddonsList.map(d => d?.ancillaryId || "").filter(d => d != "")
        const request = await refundAncillaryFromOffer(allAncillaryFulfillmentIds, bookingId)
        if (request.status === "ok" && request.code === 200) {
          if (isManageSeating) {
            sessionStorage.setItem("needToShowRemovedAddons", "yes")
          } else {
            sessionStorage.removeItem("needToShowRemovedAddons")
          }
          const refundOffers = request.answer?.refundOffers || []
          // if (refundOffers.length > 0) {
          //   const allRefundOffersIds = refundOffers.map(d => d.id)
          //   if (allRefundOffersIds.length > 0) {
          //     for (let i = 0; i < allRefundOffersIds.length; i++) {
          //       const refundOfferId = allRefundOffersIds[i];
          //       //await patchRefundOffer(refundOfferId, bookingId)
          //     }
          //     if (isManageSeating) {
          //       sessionStorage.setItem("needToShowRemovedAddons", "yes")
          //     } else {
          //       sessionStorage.removeItem("needToShowRemovedAddons")
          //     }
          //   }
          // }
        }
      }

      /**
       * Added ancillary(Addons) to booked offer
       * First prepare all the addons passenger based on ancillary for all trip
       * Second, prepare all the ancillary for all the offer
       * Third, prepare payload(API) to add ancillary to offer
      */
      if (!patchAddonsOnConfirm && (confirmAddonsList || []).length > 0) {
        const allTripLegPassengerAddons: IAddAncillaryToOfferRequest[] = []
        confirmAddonsList?.forEach(addonsDetail => {
          addonsDetail.addonsPassenger.forEach(addonsPass => {
            Object.values(addonsPass?.addonItem || {}).forEach(async (addonsItem: any) => {
              const tripLegPassengerAddons: IAddAncillaryToOfferRequest = {
                offerId: addonsItem?.additionalOfferId || "",
                bookedOfferId: addonsItem?.bookedOfferId || "",
                ancillaryOfferId: addonsItem?.ancillaryOfferId || "",
                passengerRefs: [addonsPass.passengerRef],
                tripCoverage: {
                  coveredTripId: addonsItem?.tripCoverageId || ""
                }
              };
              allTripLegPassengerAddons.push(tripLegPassengerAddons)
            })
          })
        })
        if (allTripLegPassengerAddons.length > 0) {
          const mergeOffers = allTripLegPassengerAddons.reduce((acc: any, item: IAddAncillaryToOfferRequest) => {
            const key = `${item.offerId}-${item.ancillaryOfferId}-${item.tripCoverage.coveredTripId}`;
            acc[key] = acc[key] || { ...item, passengerRefs: [] };
            acc[key].passengerRefs.push(...item.passengerRefs);
            return acc;
          }, {})

          const mergeDataOfferWise = (Object.values(mergeOffers) as IAddAncillaryToOfferRequest[]).reduce((acc: any, item: IAddAncillaryToOfferRequest) => {
            const key = `${item?.bookedOfferId}`;
            acc[key] = [
              ...acc[key] || [],
              item
            ]
            return acc;
          }, {})

          const allKeys = Object.keys(mergeDataOfferWise)
          const addonsPromises = [];
          for (let i = 0; i < allKeys.length; i++) {
            const offerId = allKeys[i]
            const offerAddons = mergeDataOfferWise[allKeys[i]]
            for (let j = 0; j < offerAddons.length; j++) {
              delete offerAddons[i]?.bookedOfferId
              const request = await addAncillaryToOffer(offerAddons[j], bookingId, offerId)
              addonsPromises.push(request)
            }
          }
          if (addonsPromises.length > 0) {
            await Promise.all(addonsPromises)
            if (isManageSeating) {
              sessionStorage.setItem("needToShowAddedAddons", "yes")
            } else {
              sessionStorage.removeItem("needToShowAddedAddons")
            }
          }
        }
      }

      const alreadyCacheData = localStorage.getItem("retrieveBookingCacheData");

      if (alreadyCacheData) {
        const data = JSON.parse(alreadyCacheData)
        localStorage.setItem("retrieveBookingCacheData", JSON.stringify({
          ...data || {},
          retrieveBooking: { bookingId: bookingId, isPastBooking: false }
        }))
      } else {
        localStorage.setItem("retrieveBookingCacheData", JSON.stringify({
          retrieveBooking: { bookingId: bookingId, isPastBooking: false }
        }))
      }

      // Refunds for deselected baseline extras are settled by the backend
      // as part of POST /api/payment/session. Mirrors PaymentProcessAction.

    } catch (error) {
      console.error("Error during payment type change:", error);
    } finally {
      return returnString
    }
  }
}

export const guestPaymentProcessAction = new GuestPaymentProcessAction();